
<template>
  <div class="page-container ">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      title="隐私政策"
    ></van-nav-bar>
    <div class="main-container main-content">
		<h3>隐私条款</h3>
		<p class="p_strong" style="text-indent: 0; font-size: 14px; ">本条款将帮助您了解以下内容：</p>
		<ul>
			<li>一、 我们如何收集您的个人及相关信息</li>
			<li>二、 我们如何使用您的个人信息</li>
			<li>三、&nbsp;我们如何使用Cookie和同类技术</li>
			<li>四、&nbsp;我们如何共享、转让、公开披露您的个人信息</li>
			<li>五、&nbsp;我们如何存储和保护您的个人信息</li>
			<li>六、&nbsp;您如何管理您的个人信息</li>
			<li>七、&nbsp;本条款的更新</li>
			<li>八、&nbsp;如何联系我们</li>
		</ul>
		<p class="pull_r">本版发布日期：2020年6月12日</p>
		<p class="pull_r">生效日期：2020年6月12日</p>
		<br>
		<p class="p_normal">为切实保护天安(贵州省)互联网金融资产交易中心股份有限公司（以下称“天安金交”或“我们”）用户个人信息和隐私权，天安金交根据现行法规及政策，制定本《隐私条款》（以下简称“本条款”）。本条款旨在帮助您了解我们将如何收集、使用并保护您的个人信息，本条款适用于天安金交向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的天安金交服务。</p>
		<p class="p_strong">本条款与您使用我们的服务密切相关，我们建议您仔细阅读并在理解本条款全部内容的基础上，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本条款中与您的权益存在重大关系的条款，采用粗体字进行标注以提示您注意。</p>
		
		<br>
		<p class="p_strong" style="font-size: 14px;">一、 我们如何收集您的个人及相关信息</p>
		<p class="p_normal">个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合，识别特定自然人身份或者反映特定自然人活动情况的各种信息，<span class="sp_strong">包括但不限于公民的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。</span>在您使用天安金交服务的过程中，为了向您提供服务、提升我们的服务质量、保障您的账户和资金安全以及符合国家法律法规规定，在以下情形中我们需要收集您的一些信息：</p>
		<p class="p_normal">1、当您直接注册账号时，我们将收集您的<span class="sp_strong">电话号码。</span>收集此类信息是为了您使用基础的浏览服务，如果您不打算使用后续天安金交所提供的服务，您可以选择不进行注册及提供上述信息。</p>
		<p class="p_normal">2、当您完善您的个人账户信息时，我们将可能收集您的<span class="sp_strong">电子邮箱、住址，</span>收集此类信息是为了让您可以接收我们最新产品消息或方便您参与相关活动。如果您不希望天安金交向您传送此类消息，您可以选择不提供上述信息。</p>
		<p class="p_normal">3、当您完善您的风险评测信息时，我们将可能收集您的<span class="sp_strong">投资经验、投资偏好、金融资产信息</span>等，收集此类信息是为了满足法律法规关于投资者适当性管理的要求，并同时为您更好的提供符合您投资偏好的产品信息等。如果您不提供上述信息，您将无法正常使用我们的服务。</p>
		<p class="p_normal">4、当您希望通过我们提供的服务进行投资时，您需要进行银行存管账户开立、银行账户绑定、充值、提现、转让等操作，我们将收集您的<span class="sp_strong">真实姓名、身份证件号码、电话号码、电子邮箱、银行账号信息</span>等，并对您的身份信息及银行账户信息进行验证。收集此类信息是为了满足相关法律法规关于资金存管的要求，并同时保障您的账户和资金安全。</p>
		<p class="p_normal">5、如您使用了我们提供的金融服务时，我们将收集您的金融<span class="sp_strong">交易信息</span>，包括金融产品（或服务）金额、期限、时间、交易合同及相关材料等，我们还将收集您的<span class="sp_strong">充值、提现记录以及您存管账户中的财产信息（包括总资产、账户余额、资金流水等财产信息），</span>收集此类信息是为了完成资金清算、账务核对和合同及交易纪录保管等服务，如果您不提供此类信息，您将无法正常使用我们的服务。</p>
		<p class="p_normal">6、我们将在您使用我们提供的产品或服务的过程中收集您的<span class="sp_strong">个人常用设备信息（例如IMEI/OAID编号、GAID编号、IMSI编号、MAC地址、序列号、系统版本及类型、ROM版本、Android版本、Android ID、Space ID、SIM卡运营商和归属地、屏幕显示信息、设备输入信息、设备激活时间、设备制造商信息和型号名称、网络运营商、连接类型、硬件基础配置信息、销售渠道及使用相关信息（例如CPU、内存、电量使用情况、设备分辨率）等）和日志信息（如访问内容、IP地址、访问日期和时间及访问记录等），</span>收集这些信息是为了向您提供更好的产品和/或服务并改善用户体验。</p>
		<p class="p_strong">7、您同意我们可以自行或通过第三方对您提交或我们收集的用户信息进行核实、验证，并对获得的核实、验证结果进行查看、收集、使用和留存等操作。</p>
		<p class="p_strong">8、根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集您的个人信息无需征得您的同意:</p>
		<p class="p_strong">（1）与国家安全、国防安全直接相关的；</p>
		<p class="p_strong">（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p class="p_strong">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p class="p_strong">（4）出于维护您或他人的生命、财产等重大合法权益；</p>
		<p class="p_strong">（5）所收集的个人信息是您自行向社会公众公开的；</p>
		<p class="p_strong">（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</p>
		<p class="p_strong">（7）根据您的要求签订和履行合同所必需的；</p>
		<p class="p_strong">（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</p>
		<p class="p_strong">（9）法律法规规定的其他情形。</p>
		
		<br>
		<p class="p_strong" style="font-size: 14px;">二、 我们如何使用您的个人信息</p>
		<p class="p_normal">1、为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账户和资金安全，我们会在以下情形中使用您的信息；</p>
		<p class="p_normal">（1） 实现本条款中“我们如何收集您的个人信息”所述目的；</p>
		<p class="p_normal">（2） 进行用户身份识别、信息核查和验证，以审核用户的年龄、资产情况、信用情况，确保交易的合理性、安全性和防范违法犯罪活动；</p>
		<p class="p_normal">（3） <span class="sp_strong">对您的信息进行综合统计、分析加工和模型创建等内部使用，</span>以便向您提供更加准确、流畅及便捷的服务，或帮助我们评估、改善或设计产品、服务及运营活动等；</p>
		<p class="p_strong">（4） 有针对性地向您推荐我们提供的商品、服务或推广活动。您同意我们通过站内信、电子邮件、电话、短信等方式向您提供、发送服务状态的通知、营销活动及其他商业性信息。如不需要我们推广相关信息，您可联系天安金交客服取消、退订该类信息；</p>
		<p class="p_normal">（5） 根据法律法规或监管要求向相关部门进行报告；</p>
		
		<p class="p_strong">2、 您知晓并同意，在收集您的个人信息后，我们可能会通过技术手段对您的个人信息进行脱敏。我们有权在不透露您个人信息的前提下使用已经脱敏的信息。</p>
		<p class="p_strong">3、 当您使用金黔理财APP时，我们仅收集您的下述信息及/或获得您的相关授权用以实现以下目的：</p>
		<br>
		<table border="1" cellspacing="0" cellpadding="0">
			<tbody><tr style="font-weight: bold; "> <td class="td_1" style="text-align: center;">序号</td><td class="td_2" style="padding: 10px 5px; text-align: center;">所需收集信息<br>或获得的授权</td><td class="td_3" style="padding: 10px 5px; text-align: center;">用途及必要性说明</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">1</td><td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">添加或修改您的日历活动，并可读取您的日历活动及详情</td><td class="td_3" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">根据您的交易需求，通过APP在您的手机日历中添加相应的提醒事项，如：产品开售提醒、产品回款提醒等；获取您通过APP添加到日历中的提示事项，以便及时向您发起提醒。</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">2</td> <td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">将您的信息写入外部储存卡，并可读取相关信息</td> <td class="td_3" style="padding: 10px 5px;  text-align: justify; text-indent: 2em;">将您使用APP所需的姓名、手机号、邮箱、头像图片等信息存储在您的手机本地，并可读取相关信息。为保证交易主体辨识度，将对您的头像图片、脱敏后的姓名进行公开展示。</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">3</td> <td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">拨打电话</td> <td class="td_3" style="padding: 10px 5px;  text-align: justify; text-indent: 2em;">方便您根据自身需求直接通过APP拨打客服电话。</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">4</td> <td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">摄像头（仅获取您的相机相片等数据，不对数据进行存储）</td> <td class="td_3" style="padding: 10px 5px;  text-align: justify; text-indent: 2em;">当需要您通过人脸识别进行身份认证、通过拍照上传头像及使用扫描二维码功能时，以便您顺利开展注册、修改信息等活动。</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">5</td> <td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">查看WLAN连接</td> <td class="td_3" style="padding: 10px 5px;  text-align: justify; text-indent: 2em;">通过该项授权，监测您是否成功连接网络，以便您顺利使用APP。</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">6</td> <td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">获取粗略位置</td> <td class="td_3" style="padding: 10px 5px;  text-align: justify; text-indent: 2em;">根据产品合作方要求，部分产品仅可在特定地域销售，APP需要识别您的位置信息，以确认能否向您展示相关产品信息。</td> </tr>
			
			<tr> <td class="td_1" style="text-align: center;">7</td> <td class="td_2" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">获取精确位置</td> <td class="td_3" style="padding: 10px 5px;  text-align: justify; text-indent: 2em;">根据产品合作方要求，部分产品仅可在特定地域销售，APP需要识别您的位置信息，以确认能否向您展示相关产品信息。</td> </tr>
		</tbody></table>
		
		<br><br>
		<p class="p_strong" style="font-size: 14px;">三、 我们如何使用&nbsp;Cookie和同类技术</p>
		<p class="p_normal">为使您获得更轻松的访问体验，您访问天安金交网站或使用天安金交所提供的服务时，我们可能会通过Cookie、Flash Cookie等小型数据文件识别您的身份，这么做可以帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全状态。<span class="sp_strong">天安金交承诺对cookie信息的使用仅用于提升服务、产品质量及优化用户体验的目的。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝天安金交的Cookie，但这一举动在某些情况下可能会影响您访问天安金交网站和不能充分使用天安金交提供的服务。</span></p>
		<p class="p_normal"><span class="sp_strong">我们网站上还可能包含一些电子图像，称为“单像素GIF文件”或“网络Beacon”，使用电子图像可以帮助网站计算浏览网页的用户或访问某些Cookie，我们会通过电子图像收集您浏览网页活动的信息，</span>例如：您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</p>
		
		<br>
		<p class="p_strong" style="font-size: 14px;">四、 我们如何共享、转让、公开披露您的个人信息</p>
		<p class="p_strong">1、&nbsp;共享</p>
		<p class="p_normal">我们承诺对您的个人信息进行保密，原则上不得共享。除为了向您提供更多元化、个性化、优质的服务或法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司、合作金融机构以及其他合作伙伴。在将信息提供给第三方前，我们将合理的评估该第三方收集信息的合法性、必要性，并尽力要求第三方对您的信息采取保护措施。</p>
		<p class="p_normal">（1） 提供给依法设立的征信机构和个人信用数据机构等第三方机构，以对您进行身份验证或资信状况评估；</p>
		<p class="p_normal">（2） 为让您顺利完成交易，实现投资需求目的，提供给您的交易相关方、增信方，以及我们的关联方、合作方以用于向您提供相关服务；</p>
		<p class="p_normal">（3） 事先获得您明确同意或者在法律法规允许（与国家安全、国防安全、公共安全、公共卫生、重大公共利益或与犯罪侦查、起诉、审判和判决执行等直接相关的情形）且不违背公序良俗的情况下，我们会与第三方共享您的信息。</p>
		
		
		
		<p class="p_strong">接入第三方SDK目录</p>
		<p class="p_normal">为保障金黔理财App相关功能的实现与应用安全稳定的运行，我们会接入由第三方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关第三方SDK在目录中列明，目录所涉及到的SDK适用于装载有IOS系统或装载有Android系统的手机用户。</p>
		<p class="p_normal">请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。以下为金黔理财App所包含的三方SDK收集信息的详细列表：</p>
		<br>
		<table border="1" cellspacing="0" cellpadding="0">
			<tbody><tr style="font-weight: bold; ">
				<td class="td_11" style="text-align: center;">SDK名称</td>
				<td class="td_22" style="padding: 10px 5px; text-align: center;">手机系统</td>
				<td class="td_33" style="padding: 10px 5px; text-align: center;">用途</td>
				<td class="td_44" style="padding: 10px 5px; text-align: center;">收集个人信息类型</td>
			</tr>
			
			<tr>
				<td class="td_11" style="text-align: center;">微信公众平台SDK</td>
				<td class="td_22" style="padding: 10px 5px; text-align: justify;">iOS、Android</td>
				<td class="td_33" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">微信分享、微信收藏</td>
				<td class="td_44" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">个人常用设备信息（包括IMEI、IMSI、设备MAC地址、软件列表、设备序列号、android ID等）</td>
			</tr>
			<tr>
				<td class="td_11" style="text-align: center;">华为推送SDK</td>
				<td class="td_22" style="padding: 10px 5px; text-align: justify;">Android</td>
				<td class="td_33" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">用于向华为手机用户推送消息</td>
				<td class="td_44" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">设备标识信息（包括IMEI、IMSI、设备MAC地址、软件列表、设备序列号、android ID等）</td>
			</tr>
			<tr>
				<td class="td_11" style="text-align: center;">TBS腾讯X5浏览服务</td>
				<td class="td_22" style="padding: 10px 5px; text-align: justify;">Android</td>
				<td class="td_33" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">应用内网页浏览</td>
				<td class="td_44" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">设备标识信息（IMEI、openid等）、读写外置存储器、读取手机状态和身份</td>
			</tr>
			<tr>
				<td class="td_11" style="text-align: center;">友盟SDK</td>
				<td class="td_22" style="padding: 10px 5px; text-align: justify;">Android</td>
				<td class="td_33" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">用于App新增和崩溃等统计分析，消息推送等</td>
				<td class="td_44" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">设备标识信息（包括IMEI、IMSI、设备MAC地址、软件列表、设备序列号、android ID等）</td>
			</tr>
			<tr>
				<td class="td_11" style="text-align: center;">OKHTTP</td>
				<td class="td_22" style="padding: 10px 5px; text-align: justify;">Android</td>
				<td class="td_33" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">网络请求</td>
				<td class="td_44" style="padding: 10px 5px; text-align: justify; text-indent: 2em;">网络身份标识信息（ip地址等）</td>
			</tr>
		</tbody></table>
		
		<br>
		
		<p class="p_strong">2、&nbsp;转让</p>
		<p class="p_normal">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
		<p class="p_normal">（1） 事先获得您的明确同意；</p>
		<p class="p_normal">（2） 如涉及合并、分立、收购、资产或业务转让等类似的交易，您的个人信息可能作为此类交易的一部分而被转让，我们会向您告知有关情况，并提示新的持有您个人信息的公司、组织继续接受本条款的约束。如变更个人信息使用目的时，我们将提示该公司、组织重新取得您的明确同意；</p>
		<p class="p_normal">（3） 根据法律法规或强制性的行政或司法要求。</p>
		<p class="p_strong">3、&nbsp;公开披露</p>
		<p class="p_normal"> 我们不会将您的信息进行公开披露，但与国家安全、国防安全、公共安全、公共卫生、重大公共利益或与犯罪侦查、起诉、审判和判决执行等直接相关的情形下，我们将会依据所要求的个人信息类型和披露方式公开披露您的个人信息。</p>
		<p class="p_strong">4、&nbsp;根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、披露您的个人信息无需征得您的同意：</p>
		<p class="p_strong">（1） 与国家安全、国防安全直接相关的；</p>
		<p class="p_strong">（2） 与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p class="p_strong">（3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p class="p_strong">（4） 出于维护您或其他个人的生命、财产等重大合法权益；</p>
		<p class="p_strong">（5） 您自行向社会公众公开的个人信息；</p>
		<p class="p_strong">（6） 经您书面同意且在约定范围内公开；</p>
		<p class="p_strong">（7） 基于公共利益为学术研究或者统计的目的，以不足以识别特定信息主体的方式公开，但涉及个人敏感信息除外；</p>
		<p class="p_strong">（8） 从合法公开披露的信息中收集的个人信息，例如：合法的新闻报道、政府信息公开等渠道。</p>
		<p class="p_strong">5、 经过处理无法识别特定个人且不能复原的信息，可以不经您的同意对外提供。</p>
		
		<br>
		<p class="p_strong" style="font-size: 14px;">五、 我们如何存储和保护您的个人信息</p>
		<p class="p_normal">1、 为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。例如：通过https等方式提供浏览服务，确保用户数据在传输过程中的安全；通过网络安全层软件（SSL）进行加密保护。同时我们设立了个人信息保护责任部门，建立了数据分类分级、数据访问权限、双因素认证登录、数据备份等相关内控制度，对可能接触到您的信息的工作人员采取最小够用的授权原则。并通过定期对工作人员的培训，强化宣导相关法律法规、隐私安全准则和安全意识。目前天安金交综合交易系统已经通过信息系统安全保护等级（三级）等认证。</p>
		<p class="p_normal">2、 我们已制定个人信息安全事件应急预案，并定期组织内部相关人员进行培训和网络安全自查等，使其掌握岗位职责保证信息系统安全。尽管我们采取了上述技术安全措施，但请您理解，在互联网行业由于技术的限制和飞速发展可能存在的各种恶意攻击手段，如不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们会及时将事件相关情况以APP推送通知、发送邮件/短消息等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
		<p class="p_normal">3、 我们收集和产生的个人信息将存储在中华人民共和国境内，不会向境外传输您的个人信息。我们仅在本条款所述目的所必需期间和法律法规及监管规定的时限保存您的个人信息。</p>
		
		<br>
		<p class="p_strong" style="font-size: 14px;">六、 您如何管理您的个人信息</p>
		<p class="p_normal">我们非常重视您管理个人信息的权利，在您使用天安金交服务期间，我们为您提供了管理个人信息的方法。除法律法规另有规定外，您有权利依据天安金交相关制度规定及业务规则要求访问、修改、自己的信息，注销自己的账号。</p>
		<p class="p_normal">1、 查询权</p>
		<p class="p_strong"> 如果您希望访问或编辑您在天安金交所留下的个人资料信息（包括但不限于姓名、手机号码、电子邮箱、登录密码、银行账户信息等），您可以在天安金交的网页端或APP端中执行此类操作，为保证您的个人信息安全，部分信息为脱敏展示。</p>
		<p class="p_normal">2、更正权</p>
		<p class="p_normal">当您需要更新您的个人信息时，或信息确有错误、遗漏的、或发现我们处理的关于您的个人信息有错误时，您有权做出更新或要求我们更正。<span class="sp_strong">您可以自行在相关网页端或APP端进行编辑更正，或者通过反馈给天安金交客服的方式将您的更正申请提交给我们。</span>在您进行更新或更正前，我们可能会现要求您验证自己的身份，然后再处理您的请求。</p>
		<p class="p_normal">3、 删除权</p>
		<p class="p_normal">当您决定不再使用账户，并清偿所有应付款项或账户中无未兑付产品等之后，您可以通过拨打天安金交平台上公布的客服电话申请注销您的账户，一旦注销账户我们将停止为您提供服务，请您谨慎操作。我们经您同意进行个人信息处理，若您撤回同意或者认为我们不再具有处理您个人信息处理的其他合法性依据的，可以通知我们删除已处理的个人信息，但法律、行政法规规定不得删除或需要保留的除外。<span class="sp_strong">您知悉并理解，在您注销账户前提供的个人信息，我们会在维护您最大权益的基础上，继续依照可适用的法律法规规定及本条款进行保存、使用或披露。</span></p>
		<p class="p_strong">4、&nbsp;请您务必妥善保管好您的天安金交账户信息。在您使用天安金交服务时，我们会通过您的账户信息来识别您的身份，使用您的天安金交用户名和密码登录天安金交后的一切行为均代表由您本人作出，一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。如您发现前述可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
		<p class="p_normal">5、 尽管有上述约定，但按照相关法律法规及国家标准，在以下情形中，我们可能无法响应您的请求：</p>
		<p class="p_strong">（1） 与国家安全、国防安全直接相关的；</p>
		<p class="p_strong">（2）&nbsp;与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p class="p_strong">（3） 与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
		<p class="p_strong">（4） 有充分证据表明您存在主观恶意或滥用权利的；</p>
		<p class="p_strong">（5） 响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</p>
		<p class="p_strong">（6） 涉及商业秘密的。</p>
		
		<br>
		<p class="p_strong" style="font-size: 14px;">七、 本条款的更新</p>
		<p class="p_strong">发生下列重大变化情形时，我们可能会对本条款进行更新：1、&nbsp;我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；2、&nbsp;收集、存储、使用个人信息的范围、目的、规则发生变化；3、&nbsp;对外提供个人信息的对象、范围、目的发生变化；4、&nbsp;您访问和管理个人信息的方式发生变化；5、&nbsp;数据安全能力、信息安全风险发生变化；6、&nbsp;用户询问、投诉渠道以及联络方式发生变化；7、&nbsp;其他可能对您的个人信息权益产生重大影响的变化。</p>
		<p class="p_strong">由于天安金交的用户较多，如本条款发生更新，我们将以APP消息通知、发送邮件/短消息或者在天安金交官方网站发布公告的方式来通知您。如您在本条款更新生效后继续使用天安金交的服务，即表示您已充分阅读、理解更新后的条款并愿意接受其约束。</p>
		<p class="p_strong">八、 如何联系我们</p>
		<p class="p_normal">如果您对本隐私保护条款或数据处理有任何疑问、投诉或建议，或认为我们有可能损害您个人信息相关知情权、同意权、查询权、更正权、拒绝权、删除权，可以通过天安金交平台上的客服电话（400-694-0070）与我们联系。</p>
		<p class="p_normal">一般情况下，我们将在收到您相关联系信息后十天内回复。</p>
		<br><br>
	</div>
    </div>
</template>    
<script>

import { NavBar } from 'vant'
export default {
  name: 'userPrivacy',
  components: {
    [NavBar.name]: NavBar,
  },
}
</script>


   <style lang="less" scoped>
   .main-content {
    font-size: 12px;
    font-family: '微软雅黑',"宋体","Arial Narrow",Helvetica,sans-serif;
    color: #000;
    line-height: 1.2;
    text-align: left;
}
    .main-container{
      margin: 10px 20px;
   }
   p.p_strong{
      text-indent: 2em;
      // padding: 5px 0;
      font-size: 12px;
      font-weight: bold;
      text-align: justify;
      line-height: 16px;
   }
   .pull_r {
      text-align: right;
      margin-bottom: 0;
      padding-bottom: 0;
      font-size: 12px;
      font-weight: bold;
      line-height: 16px;
   }
   p.p_normal {
      text-indent: 2em;
      font-size: 12px;
      // padding: 5px 0;
      text-align: justify;
      line-height: 16px;
   }
   .sp_strong {
      font-weight: bold;
   }
   table tr .td_1 {
      width: 10%;
   }
   table tr .td_2 {
    width: 35%;
   }
   table tr .td_3 {
      width: 55%;
   }
   table tr .td_11 {
      width: 18%;
   }
   table tr .td_22 {
      width: 16%;
   }
   table tr .td_33 {
      width: 22%;
   }
   table tr .td_44 {
      width: 44%;
   }
   </style>